setTimeout(() => {
    let klaviyoForm = document.querySelector('.klaviyo-form');
    let cartButton = document.querySelector('.gfbVolumeDiscountWidgetOfferAddToCartContainer');
    let cartButtonPDP = document.querySelector('.product-form__submit span');
    let buttonBundle = document.querySelector('.gfbFrequentBoughtAddToCartButtonSection');
    if (cartButton && cartButton.textContent && cartButton.textContent.trim().toLowerCase()  && klaviyoForm !== null ) { //||
        //buttonBundle && buttonBundle.textContent && buttonBundle.textContent.trim().toLowerCase()  && klaviyoForm !== null) {
            const elementos = document.querySelectorAll('.product__info-wrapper [id*="bundle"]');
            elementos[0].style.display = 'none';
        if (klaviyoForm) {
            klaviyoForm.style.display = 'flex';
        }
    }
}, 3003);
